import React from 'react'
import { Paginator } from 'primereact/paginator'
import { Dropdown } from 'primereact/dropdown'
import { classNames } from 'primereact/utils'
import { Ripple } from 'primereact/ripple'
import { FaArrowLeftLong, FaArrowRightLong } from 'react-icons/fa6'
import { useTranslation } from 'react-i18next'

function LabPagination ({
  currentPage,
  rowsPerPage,
  totalRecords,
  onPageChange
}) {
  const { t } = useTranslation()

  const handlePageChange = event => {
    onPageChange(event.page + 1, event.rows)
  }

  const template = {
    layout:
      'PrevPageLink PageLinks NextPageLink RowsPerPageDropdown CurrentPageReport',

    PrevPageLink: options => (
      <button
        type='button'
        className={classNames(options.className, 'border-round')}
        onClick={options.onClick}
        disabled={options.disabled}
      >
        <span className='flex justify-center p-3 gap-2 items-center'>
          <FaArrowLeftLong />
          {t('Previous')}
        </span>
        <Ripple />
      </button>
    ),

    NextPageLink: options => (
      <button
        type='button'
        className={classNames(options.className, 'border-round')}
        onClick={options.onClick}
        disabled={options.disabled}
      >
        <span className='flex justify-center p-3 gap-2 items-center'>
          {t('Next')}
          <FaArrowRightLong />
        </span>
        <Ripple />
      </button>
    ),

    PageLinks: options => {
      if (
        (options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(options.className, { 'p-disabled': true })
        return (
          <span className={className} style={{ userSelect: 'none' }}>
            ...
          </span>
        )
      }
      return (
        <button
          type='button'
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      )
    },

    RowsPerPageDropdown: options => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 }
      ]
      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={options.onChange}
          className='!h-[32px] !w-20'
          pt={{
            root: { className: 'w-full md:w-full p-primary-input' },
            input: {
              className: 'w-full p-primary-input !p-0 !px-1 flex items-center'
            },
            filterInput: { className: 'mr-0' },
            filterIcon: {
              className: 'rtl:right-auto rtl:left-4 dark:text-white'
            }
          }}
        />
      )
    },

    CurrentPageReport: () => (
      <span className='mx-3'>{`${t('TotalRecords')} ${totalRecords}`}</span>
    )
  }

  return (
    <div className='!mt-4 w-full'>
      <Paginator
        first={(currentPage - 1) * rowsPerPage}
        rows={rowsPerPage}
        totalRecords={totalRecords}
        rowsPerPageOptions={[10, 20, 30]}
        onPageChange={handlePageChange}
        template={template}
        className='!bg-transparent flex justify-center gap-5 items-center'
        pt={{
          pages: { className: 'flex gap-4 items-center' }
        }}
      />
    </div>
  )
}

export default LabPagination
